var _rect, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSoftwareDevelopmentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 30,
    viewBox: "0 0 29 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 29,
    height: 30,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_515_41",
    transform: "translate(-0.0172414) scale(0.0161638 0.015625)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_515_41",
    width: 64,
    height: 64,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAABmJLR0QA/wD/AP+gvaeTAAAE50lEQVR4nO2bbYhVRRjHf3tb3dLSaxAsUS1RiGAUgUa0S225FZG9GoW1+qUiCqJgC6kPsSB9LCj8VPSeWRHYi2TFCgaVlvZKpLXdoA/5hqAovayrbh+eOd45s+fcmTnn3Dl37/qH4c7MMy/P878zc+aZM6eDyZgNDAAXADMS5FMRR4AaMAL8k1aoA3gcOAhMtGk4AAwpW2OoAG+1gIKhwtqIhE5FwBCwXCOkBmxSjLUD5gFLkGkNcDfwLfAsyJzXh/2LQFd4HZuOLuAl4tNhFsDNWuYo7Wl8hC5kdEf2Lq0A87UCI8BYCYqFwhhiY4T5ncDpWsZeo0IFuAc4W6V3IQvIcUd5K2K3Fp/TmVpMMAi8lpD/hqO85VGxyCcseTZ5y8M2AtYiBl2k0j8j+wVXecvDRsBx4M0c8paHbQq0PaY9AeYU6AVWlaFIQPTqCZOAARWmDU5OASP9JfBFGYoERB/aNDAJGAGGg6oTHsNoBEz7KXCSgJL7P1+F0lAmAdcgBzCjQH9ZSpRJQB9wigpXlqVEmQRUUuLBlTiipdv5OCxCzN4K8B5yUFhT8XZHUHuXAR8BtyfIhqmfziZtvhrVnTKI3jccTJDZCGhUtzA0e/GZa/yGquuMsjdCpaMIAmYClxL2Vfos4CrgtLwN5SWgCnwOfAdszKuMBz4GNgNbgLPyNJSHgCrwKXC5Svciu7oQWKh+L0Fc+MwkZCUgMv4yLW8VcCyrIp64DxhX8YvJSYIv5gJbiV84eCKlrF7GhO0x2KguwI3Af1qZX4BuJws80A88D7wLPAfcAHxtKDfUoH4zCQC4DdnaRuV+BO4EXgE+A14GbiLhSowNpwJvG0okhUbG24woggCYTEJS2IC6DOGKFywNuhhvM6IoAkBIGLfo+3pSxaRF8ELgXi29BhlGawzl3ndQLBS+J/4EStJ5EFjg0tiD1Fn70JBt0GQPOLQVagSsdNT5IbNi0gjQ9941Q/a7Fp/noFgozNHijXQ+w6yYRIBe4S7gPBXvUekIox4KNhuuOv/q0ths5K5QNGz+Brar3yhvrypnQ6gp0AX8adH5Lzx8h1uAo4YSUTiq5C4IRQDIRcixFJ3HgOsc2zmBa4GdRkM7Vb4LqhRHQNWxzyuAbUbd7So/EzqQ+z8D1B0QF1SJ7xiznAgdIG7EmR799yBOWo9HncJgGj8BPJxQzkbAcuLT8AcCOjxZ4eMo2QgAWcH1Hd4O6pcyC4Htllgj9CMntt3I7ctPEEN0F/kx4JkcfbyDnDS9iuz0FiC32J8CrgfOBfYAHwDrcV8wc6EoR8llBEQYJP2pFIVNNPkANUJRjpIPASAkHLP0u97DDsD/RKhMR2mzkU7q+1ZgURP6PoEiHaUsI8Clb69rfr6LYBGO0kzgSeARLe9Rpctq0l/QZnZ4isQd1JneRdzp2K3JlqXU70Te96XN4Y2kv19Y4tj3ikyWOSKvo3Q/cYN/Q7xKPS9t+sxA/ulGfe8nwJMgj6Ok79NXq7wO4Gkt/5sG9fuAf1P6HkeOxoIgq6N0WCuv/1O643TY0sYi4Cuj75+Aq70sKABZHKV91JXWH1eLtXzzu6U0nIM4PKXeMvPFOuqG1pAFawXwh5a/rjTtAmAh6XN4Avmw2cftnpJYChxisvGHlCwovF8ZFYRu5JG4WKW3IZ/s7gmtyP+yYYXiJ+wq5wAAAABJRU5ErkJggg=="
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoftwareDevelopmentIcon);
export default __webpack_public_path__ + "static/media/Software Development Icon.4f72580bf145617f5d0fdbae491a2a1c.svg";
export { ForwardRef as ReactComponent };